module.exports = __webpack_public_path__ + "static/catalogo-img-pq-e1563481726661-57abfa51f4fdd24906814e08ccf66518.jpg";